import { ViteSSG } from 'vite-ssg';
import { ID_INJECTION_KEY } from 'element-plus/es';
import 'element-plus/dist/index.css';
import 'virtual:svg-icons-register';
import components from './components';
import VueAnimateOnScroll from '@/directives/scroll-animate';
import VueViewPort from '@/directives/view-port';
import $confirm from '@/pages/user-execption/components/module';

import {
  fpjsPlugin,
  FpjsVueOptions
} from '@fingerprintjs/fingerprintjs-pro-vue-v3';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import { useRouterEach, routes } from './router';
import { pinia } from './store';
import { i18n } from '@/lang/i18n';
// 自定义拖拽
import Directives from '@/utils/directives';
import { envHost } from '@/config/setup';

export const createApp = ViteSSG(
  App,
  // router 实例初始化设置
  {
    routes
  },
  (context: any) => {
    const { app, router, initialState, isClient, onSSRAppRendered } = context;
    const visitorHost = envHost.replace('www', 'visitor');

    app
      .use(i18n)
      .use(pinia)
      .use(Directives)
      .use(components)
      .use(fpjsPlugin, {
        loadOptions: {
          apiKey: '5OLLFTQ28cF3z3tNfxbK',
          endpoint: [import.meta.env.MODE === 'production' ? `https://${visitorHost}` : 'https://visitor.toobit.com'],
          scriptUrlPattern: [
            import.meta.env.MODE === 'production'
              ? `https://${visitorHost}/web/v<version>/<apiKey>/loader_v<loaderVersion>.js`
              : 'https://visitor.toobit.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js'
          ]
        }
      } as FpjsVueOptions)
      .use(VueAnimateOnScroll)
      .use(VueViewPort);

    app.config.globalProperties.$confirm = $confirm;

    if (isClient) {
      pinia.state.value = (initialState.pinia) || {};

      // 暂时去除测试环境的sentry
      if (import.meta.env.MODE === 'production') {
        Sentry.init({
          app,
          // production
          dsn: 'https://356c05ad7cbcf378f1358cdccbc18740@o4508380357459968.ingest.us.sentry.io/4508522455826432',
          // test
          // dsn: 'https://5dcce3c6c81c26e29cbcbef6f7a20dc7@o4508380357459968.ingest.us.sentry.io/4508532182941697',
          integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.breadcrumbsIntegration({
              console: false
            }),
            Sentry.extraErrorDataIntegration(),
            Sentry.vueIntegration({
              tracingOptions: {
                trackComponents: true
              }
            })
          // Sentry.replayIntegration({
          //   maskAllText: true,
          //   blockAllMedia: true
          // })
          ],
          maxBreadcrumbs: 10,
          allowUrls: [/https?:\/\/((www)\.)?wcsbapp\.[a-z0-1]{1,}/, /https?:\/\/((www)\.)?toobit\.[a-z0-1]{1,}/],
          // Session Replay
          // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
          // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
          tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1,
          // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
          // tracePropagationTargets: import.meta.env.MODE === 'production'
          //   ? [/^https:\/\/bapi.toobit.com\/(api|bapi)/]
          //   : [/^https:\/\/bapi.test1.wcsbsapp.com\/(api|bapi)/]
          ignoreErrors: [
            'ResizeObserver loop limit exceeded'
          ],
          beforeSend(event: any) {
            // 如果事件包含异常信息，检查堆栈跟踪中的帧是否符合允许的 URL
            if (event.exception?.values?.[0]?.stacktrace?.frames) {
              for (const frame of event.exception.values[0].stacktrace.frames) {
              // 如果任何帧不符合允许的 URL，则丢弃该事件
                if (!/^https?:\/\/((www\.)?toobit\.[a-z]{2,})/.test(frame.filename)) {
                  return null;
                }
              }
            }

            // 检查是否有 HTTP 请求错误，并确保其 URL 符合允许的模式
            if (event.request && !/^https?:\/\/((www\.)?toobit\.[a-z]{2,})/.test(event.request.url)) {
              return null; // 不发送不符合条件的 HTTP 请求错误
            }

            return event;
          }
        });
      }
    } else {
      app.provide(ID_INJECTION_KEY, {
        prefix: 100,
        current: 0
      });

      onSSRAppRendered(() => {
        initialState.pinia = pinia.state.value;
      });
    }

    // Object.values(import.meta.glob<{ install: UserModule }>('./modules/*.ts', { eager: true }))
    //   .forEach(i => i.install?.(context));

    // 加载路由钩子事件
    useRouterEach(router);
  }
);
